import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innnovaonrentinpune() {



    const cardData = {

keyword: "Innova On Rent in Pune",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Innova On Rent in Pune for family trips, corporate travel, airport transfers, weddings, and outstation journeys. We provide well-maintained Toyota Innova and Innova Crysta vehicles with spacious seating, powerful AC, ample luggage space, and experienced chauffeurs for smooth and safe travel. With doorstep pickup across Pune, flexible rental options, one-way and round-trip services, 24/7 support, and transparent pricing, we ensure a comfortable and hassle-free travel experience for all group sizes.",

topPlaces: [
    {
        title: "Lonavala & Khandala Hill Station",
        description:
            "Lonavala and Khandala are the most popular weekend destinations near Pune, known for lush green valleys, waterfalls, and scenic viewpoints. Innova rentals are ideal for family groups and friends who want a comfortable and spacious ride for monsoon trips and short getaways."
    },
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberry farms, viewpoints, and cool weather. Traveling in an Innova ensures a smooth and comfortable journey for families and groups exploring waterfalls, lakes, and scenic attractions."
    },
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra. Innova on rent is widely preferred for family darshan trips, offering a comfortable and relaxed journey for devotees visiting Sai Baba’s temple from Pune."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual and cultural hub known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. Innova is perfect for group travel covering both pilgrimage and leisure experiences in a comfortable and smooth journey."
    },
    {
        title: "Goa Beach Vacation",
        description:
            "Goa is a popular long-distance destination known for beaches, nightlife, and water sports. Innova rental is ideal for families and friends traveling together, offering a comfortable highway journey and spacious seating for luggage and passengers."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Innova is commonly used for group spiritual tours, ensuring comfort and convenience for families completing the holy darshan circuit from Pune."
    },
    {
        title: "Alibaug Coastal Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. Innova rentals are perfect for family outings, weekend trips, and corporate leisure travel from Pune for a relaxing beach experience."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular pilgrimage destination where Innova provides a comfortable and safe journey for devotees and nature lovers."
    },
    {
        title: "Konkan Coastal Tour",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, and Harihareshwar offers scenic beaches and greenery. Innova is ideal for long family vacations and group travel along the beautiful coastal highways from Pune."
    },
    {
        title: "Pune Airport Transfers",
        description:
            "Innova is widely used for Pune airport pickup and drop services, offering spacious, comfortable, and timely transportation for families, corporate clients, and VIP travelers with luggage convenience."
    }
],



services: [
{
name: "Innova on Rent in Pune",
description: "Rising Cab Service offers Innova on Rent in Pune for comfortable and reliable group travel, family trips, airport transfers, and outstation journeys. Our Innova vehicles are well-maintained, fully AC, and equipped with spacious seating and ample luggage space, making them ideal for long-distance travel and city tours. We provide professional, experienced chauffeurs who ensure safe driving, timely pickup, and smooth door-to-door service across Pune, PCMC, and all major Maharashtra routes. Whether you need a cab for Mumbai, Goa, Nashik, Shirdi, or local travel, our Innova rental service guarantees a comfortable, affordable, and hassle-free travel experience for families and corporate groups with flexible booking options and 24x7 support."
},
{
name: "Innova Crysta on Rent in Pune",
description: "Book Innova Crysta on Rent in Pune with Rising Cab Service for a premium travel experience designed for comfort, luxury, and safety. Our Innova Crysta fleet features plush seating, superior suspension, powerful AC, and extra legroom, making it perfect for long outstation journeys, weddings, and family vacations. We ensure clean, sanitized vehicles and trained chauffeurs who provide smooth driving on highways and city routes. With doorstep pickup, flexible travel plans, and transparent pricing, our service is ideal for airport transfers, corporate travel, and leisure trips to destinations like Lonavala, Mahabaleshwar, Goa, and Shirdi, ensuring a stress-free and premium travel experience every time."
},
{
name: "Innova Car Rental Pune",
description: "Rising Cab Service provides Innova Car Rental in Pune for safe, comfortable, and affordable travel solutions for families, tourists, and business travelers. Our rental service includes well-maintained Innova cars with AC comfort, spacious interiors, and experienced drivers for both local and outstation journeys. We offer flexible booking options, hourly and full-day rentals, and customized travel plans to suit your needs. Whether it is a city ride, airport transfer, or long-distance trip, our Innova car rental service ensures reliability, punctuality, and a smooth travel experience across Maharashtra and nearby states."
},
{
name: "Innova Crysta Rental Pune",
description: "Book Innova Crysta Rental in Pune for a premium and comfortable travel experience with Rising Cab Service. Our Crysta vehicles are ideal for long-distance journeys, offering luxury seating, smooth suspension, and high safety standards. Perfect for family tours, corporate trips, and pilgrimage travel, our service includes professional chauffeurs, on-time pickup, and flexible itineraries. We provide transparent pricing with no hidden charges, ensuring a stress-free travel experience to destinations like Goa, Shirdi, Mumbai, Mahabaleshwar, and other outstation routes from Pune."
},
{
name: "7 Seater Innova on Rent in Pune",
description: "Rising Cab Service offers 7 Seater Innova on Rent in Pune for small families and groups seeking comfortable and safe travel. Our Innova vehicles are spacious, air-conditioned, and ideal for both local and outstation trips. With experienced drivers and door-to-door service, we ensure smooth travel experiences for airport transfers, weekend trips, and long journeys. Whether traveling to hill stations, religious places, or business destinations, our 7-seater Innova rental service provides affordability, reliability, and maximum comfort for every ride."
},
{
name: "Hire Innova in Pune",
description: "Hire Innova in Pune with Rising Cab Service for dependable and flexible travel solutions tailored to your needs. Our Innova fleet is perfect for city travel, corporate transfers, weddings, and long-distance tours, offering comfort, safety, and convenience. We provide trained chauffeurs, clean vehicles, and 24x7 booking support to ensure a smooth travel experience. With customizable packages and transparent pricing, our service guarantees stress-free transportation across Pune, Maharashtra, and interstate routes."
},
{
name: "Innova AC Rate Per Km in Pune",
description: "Get the best Innova AC Rate Per Km in Pune with Rising Cab Service offering affordable and transparent pricing for all travel needs. Our rates are designed for both local and outstation trips, ensuring budget-friendly travel without compromising comfort. We provide well-maintained AC Innova cars with experienced drivers, making long-distance journeys safe and smooth. Whether you are traveling for business, family trips, or pilgrimage tours, our per-km pricing ensures fair billing and complete cost transparency."
},
{
name: "Innova Booking Pune",
description: "Rising Cab Service provides easy Innova Booking in Pune with instant confirmation, multiple vehicle options, and 24x7 customer support. Our booking process is simple and flexible, allowing you to schedule rides for local travel, airport transfers, or outstation trips. We ensure clean vehicles, professional drivers, and on-time service for every booking. Whether for personal or corporate travel, our Innova booking service guarantees a smooth and reliable transportation experience."
},
{
name: "Innova Cab Booking in Pune",
description: "Book Innova Cab in Pune with Rising Cab Service for safe, comfortable, and affordable travel across the city and beyond. Our cab booking service offers well-maintained vehicles, experienced chauffeurs, and flexible travel plans for hourly, daily, and long-distance trips. We specialize in airport transfers, outstation tours, and family travel packages, ensuring a seamless and stress-free journey with complete customer support."
},
{
name: "Innova Cab in Pune",
description: "Rising Cab Service offers reliable Innova Cab in Pune for all types of travel including city rides, airport transfers, and outstation journeys. Our Innova cabs are clean, spacious, and driven by professional chauffeurs to ensure safe and comfortable travel. With flexible booking options and competitive pricing, we provide a convenient transportation solution for families, tourists, and corporate travelers."
},
{
name: "Innova Cab Service in Pune",
description: "Our Innova Cab Service in Pune is designed for premium comfort and reliable travel experiences. We offer well-maintained vehicles with AC comfort, spacious seating, and experienced drivers for local and long-distance journeys. Whether you need a cab for business meetings, airport transfers, or family tours, we ensure timely pickup, smooth rides, and 24x7 customer support for a hassle-free experience."
},
{
name: "Innova Car Hire in Pune",
description: "Rising Cab Service provides Innova Car Hire in Pune for flexible and comfortable travel solutions across Maharashtra. Our fleet includes well-maintained Innova vehicles suitable for family trips, corporate travel, and outstation journeys. With professional drivers and door-to-door service, we ensure safe, reliable, and affordable travel experiences tailored to your schedule."
},
{
name: "Innova Car on Rent in Pune",
description: "Book Innova Car on Rent in Pune for convenient and comfortable travel with Rising Cab Service. Our rental cars are ideal for long-distance trips, airport transfers, and city travel, offering spacious interiors, AC comfort, and smooth rides. We provide experienced chauffeurs and flexible booking options to ensure a stress-free journey."
},
{
name: "Innova Car Rental Per Km in Pune",
description: "Get transparent Innova Car Rental Per Km in Pune with affordable pricing and no hidden charges. Our per-km rate system ensures fair billing for both local and outstation travel. We offer clean vehicles, professional drivers, and reliable service for all types of journeys across Maharashtra."
},
{
name: "Innova Crysta on Rent Pune",
description: "Rising Cab Service offers Innova Crysta on Rent in Pune for premium travel comfort and luxury journeys. Ideal for families, corporate trips, and long-distance tours, our Crysta cars provide superior seating, AC comfort, and smooth driving experience with trained chauffeurs."
},
{
name: "Innova Crysta Rent in Pune",
description: "Book Innova Crysta Rent in Pune for a comfortable and premium travel experience. Our service includes well-maintained luxury vehicles, experienced drivers, and flexible travel plans for outstation and local journeys."
},
{
name: "Innova Rent Per Km in Pune",
description: "Get the best Innova Rent Per Km in Pune with transparent pricing and affordable travel solutions. We ensure cost-effective travel for both short and long-distance routes with professional service and clean vehicles."
},
{
name: "Innova Taxi in Pune",
description: "Rising Cab Service provides reliable Innova Taxi in Pune for local and outstation travel. Our taxis are comfortable, AC-enabled, and driven by experienced chauffeurs for safe and smooth journeys."
},
{
name: "Innova Taxi Service in Pune",
description: "Book Innova Taxi Service in Pune for dependable transportation across city and outstation routes. We offer timely pickups, professional drivers, and comfortable vehicles for all travel needs."
},
{
name: "Pune Innova Cabs",
description: "Rising Cab Service provides Pune Innova Cabs for safe, comfortable, and affordable travel solutions. Our fleet is ideal for family trips, airport transfers, corporate travel, and long-distance journeys with complete reliability and comfort."
}
],

tableData: [
["Innova on Rent in Pune","Innova Crysta on Rent in Pune"],
["Innova Car Rental Pune","Innova Crysta Rental Pune"],
["7 Seater Innova on Rent in Pune","Hire Innova in Pune"],
["Innova AC Rate Per Km in Pune","Innova Booking Pune"],
["Innova Cab Booking in Pune","Innova Cab Service in Pune"],
["Innova Car Hire in Pune","Innova Car on Rent in Pune"],
["Innova Car Rental Per Km in Pune","Innova Crysta Rent in Pune"],
["Innova Taxi in Pune","Innova Taxi Service in Pune"],
["Pune Innova Cabs","Innova Crysta on Rent Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Premium Innova on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable Innova rental services in Pune for family trips, corporate travel, airport transfers, outstation tours, weddings, and sightseeing journeys."
    },
    {
        WhyChooseheading: "Spacious and Comfortable Travel Experience",
        WhyChoosedescription: "Toyota Innova offers spacious seating, excellent legroom, ample luggage capacity, and superior ride comfort for both short and long-distance travel."
    },
    {
        WhyChooseheading: "Ideal for Family and Group Travel",
        WhyChoosedescription: "Innova is one of the most preferred vehicles for family vacations, pilgrimage tours, corporate trips, group outings, and weekend getaways."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Travel",
        WhyChoosedescription: "Our Innova rental services are available for Pune city travel and destinations including Mumbai, Shirdi, Mahabaleshwar, Goa, Nashik, Kolhapur, Konkan, and more."
    },
    {
        WhyChooseheading: "Perfect for Airport and Corporate Transfers",
        WhyChoosedescription: "Innova is widely preferred for Pune Airport transfers, Mumbai Airport travel, executive transportation, and business travel requirements."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Innova pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway travel, punctual service, and a comfortable journey throughout the trip."
    },
    {
        WhyChooseheading: "Best Choice for Tours and Special Events",
        WhyChoosedescription: "Innova rentals are perfect for weddings, family functions, corporate events, pilgrimage tours, sightseeing trips, and holiday travel."
    }
]
};

const faqData = [
    {
        question: "Why is Innova one of the most popular rental vehicles in Pune?",
        answer: "Toyota Innova is known for its spacious seating, comfort, reliability, luggage space, and suitability for both local and outstation travel."
    },
    {
        question: "Can I hire an Innova for outstation trips from Pune?",
        answer: "Yes, Innova vehicles are available for outstation destinations across Maharashtra and various states in India."
    },
    {
        question: "Is Innova suitable for family vacations?",
        answer: "Yes, Innova is one of the most preferred vehicles for family holidays, sightseeing tours, and long-distance travel."
    },
    {
        question: "Can I book an Innova for airport transfers?",
        answer: "Yes, Innova rentals are available for Pune Airport, Mumbai Airport, and other airport transfer requirements."
    },
    {
        question: "Do you provide Innova for corporate travel?",
        answer: "Yes, Innova is widely used for executive transportation, employee travel, conferences, and business meetings."
    },
    {
        question: "Can Innova be booked for pilgrimage tours?",
        answer: "Yes, Innova vehicles are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Is the vehicle suitable for long-distance journeys?",
        answer: "Yes, Innova offers excellent comfort, spacious interiors, and smooth performance for long-distance travel."
    },
    {
        question: "Can I hire an Innova for weddings and family events?",
        answer: "Yes, Innova rentals are available for wedding transportation, family functions, and special occasions."
    },
    {
        question: "Do you provide pickup from Pune Railway Station and Airport?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book an Innova on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kiran Jagtap",
        feedback:
            "We hired an Innova for our Mahabaleshwar family trip. The vehicle was spacious, comfortable, and perfect for long-distance travel with luggage.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Deshmukh",
        feedback:
            "Our airport transfer and outstation travel experience was excellent. The Innova was clean, well-maintained, and the driver was highly professional.",
        rating: 5
    }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Innova on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/innova-on-rent-pune.jpg",
"description": "Book Innova on Rent in Pune with Rising Cab Service for comfortable family travel, airport transfers, corporate trips, and outstation journeys. Choose Innova and Innova Crysta with AC, spacious seating, and experienced drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/innova-on-rent-in-pune"
}
};







    return (
        <div>

<Helmet>
  <title>Innova on Rent in Pune | Innova Crysta Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Innova on Rent in Pune for family trips, airport transfers, corporate travel, and outstation journeys. Get Innova and Innova Crysta AC cars with professional drivers."
/>

<meta
 name="keywords"
 content="innova on rent in pune, innova crysta on rent in pune, innova car rental pune, innova crysta rental pune, 7 seater innova on rent in pune, hire innova in pune, innova cab booking pune, innova cab service pune, innova car hire pune, innova car on rent per km pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innnovaonrentinpune;